import type { FillApplicationState } from '@/models/fillApplication'
import type { Org } from '@/models/user'
import { DuplicateCustomerNotice } from './DuplicateCustomerNotice'
import { FillApplicationForm } from './FillApplicationForm'
import type { FillStep } from './fillSteps'

interface FormViewProps {
  orgId: string
  organisation: Org
  state: FillApplicationState
  initialStep: FillStep | null
}

export function FormView({ orgId, organisation, state, initialStep }: FormViewProps) {
  return (
    <div className="flex flex-col gap-6">
      {state.duplicateOf && <DuplicateCustomerNotice duplicate={state.duplicateOf} />}
      <FillApplicationForm
        orgId={orgId}
        organisation={organisation}
        state={state}
        initialStep={initialStep}
      />
    </div>
  )
}
